// extracted by mini-css-extract-plugin
module.exports = {"dealgo":"DealAndGoLogo_dealgo__qCV8b","dealgoEmphasis2":"DealAndGoLogo_dealgoEmphasis2__2fl2s"};